export default "__VITE_ASSET__757201c6__"